import {
    CLOSE_MENU,
    CLOSE_SEARCH,
    CLOSE_TOP_MENU,
    OPEN_MENU,
    OPEN_SEARCH,
    OPEN_TOP_MENU,
    SET_ACTIVE_TOP_LABEL,
    SET_BANNER_STATE,
    SET_HEADER_STATE,
    TOGGLE_HEADER,
} from "./constants";

import produce from "immer";

// The initial state of this store.
const initialState = {
    states: {
        menuIsOpen: false,
        topMenuIsOpen: false,
        searchIsOpen: false,
        headerIsMinimized: false,
        bannerIsActive: false,
        activeNavTopLabel: null,
    },
    data: {},
};

export default produce((state, action) => {
    switch (action.type) {
        case CLOSE_MENU:
            state.states.menuIsOpen = false;
            state.states.activeNavTopLabel = null;
            break;
        case CLOSE_SEARCH:
            state.states.searchIsOpen = false;
            break;
        case CLOSE_TOP_MENU:
            state.states.topMenuIsOpen = false;
            break;
        case OPEN_MENU:
            state.states.topMenuIsOpen = false;
            state.states.menuIsOpen = true;
            break;
        case OPEN_SEARCH:
            state.states.menuIsOpen = false;
            state.states.topMenuIsOpen = false;
            state.states.searchIsOpen = true;
            break;
        case OPEN_TOP_MENU:
            state.states.topMenuIsOpen = true;
            break;
        case SET_ACTIVE_TOP_LABEL:
            state.states.activeNavTopLabel = action.activeNavTopLabel;
            break;
        case SET_BANNER_STATE:
            state.states.bannerIsActive = action.bannerIsActive;
            break;
        case TOGGLE_HEADER:
            state.states.headerIsMinimized = action.headerIsMinimized;
            break;
        case SET_HEADER_STATE:
            state.data = action.headerState;
            break;
        default:
            break;
    }
}, initialState);
